import React from "react";
import { cn } from "../../../../../utils/cn";

const EmailHero = ({
  title,
  description,
  font_title,
  image,
  useLightTextColor,
}) => {
  const fontFamily = `'${font_title}'`;
  const textColor = useLightTextColor ? "text-white" : "text-black";

  return (
    <div className="flex flex-col items-center justify-center w-full">
      {image && (
        <div className="relative h-[132px] w-[132px] overflow-hidden rounded-full border-[7px] border-white bg-white shadow-[1px_4px_26px_rgba(0,16,28,0.12)]">
          <img
            src={image}
            alt="logo"
            className="h-full w-full rounded-full object-cover"
            width={120}
            height={120}
            loading="lazy"
          />
        </div>
      )}

      {title && (
        <h2
          className={cn(
            "word-break-fix mt-[20px] flex w-full items-center justify-center text-center text-xl leading-none font-bold subpixel-antialiased xs:text-2xl xs:leading-[27px]",
            textColor,
          )}
          style={{ fontFamily }}
        >
          {title}
        </h2>
      )}

      {description && (
        <p
          className={cn(
            "word-break-fix mt-8 flex w-full items-center justify-center text-center text-sm leading-tight text-balance whitespace-pre-line xs:text-base xs:leading-5",
            textColor,
          )}
          style={{ fontFamily }}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default EmailHero;
